
	import { Component, ProvideReactive, Vue, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
	import HamburgerSVG from '@/components/HamburgerSVG.vue';
	import SquareSVG from '@/components/SquareSVG.vue';
	import EditSVG from '@/components/EditSVG.vue';
	import ShoeSizePicker from '@/components/ShoeSizePicker.vue';
	import ShoeSizeModal from '@/components/ShoeSizeModal.vue';
	import HelpModal from './HelpModal.vue';
	import PrescriptionForm from '@/components/new-prescription/PrescriptionForm.vue';
	import { SavedRxNames } from '@/store/engine/modules/SavedRxModule';
	import Loading from '@/components/Loading.vue';
	import { SessionStatusEnum } from '@/store/engine/openapi/generated';
	import MagnifierSVG from '@/components/MagnifierSVG.vue';
	import { UiContextRecord } from '@/store/leroyUtils/uxContextDataDefinition';
	import { OrthoticStyle } from '@/store/Products';
	import { orthoticStyleToTitle } from '@/utils';
	import { orthoticStyleToImagePath } from '@/utils';

	@Observer
	@Component({
		components: {
			MagnifierSVG,
			PrescriptionForm,
			'overlay-scrollbars': OverlayScrollbarsComponent,
			HamburgerSVG,
			SquareSVG,
			EditSVG,
			ShoeSizePicker,
			ShoeSizeModal,
			HelpModal,
			Loading
		}
	})
	export default class FormView extends Vue {
		private categoryContainer!: Element;
		private shoeSizePicker = false;
		@ProvideReactive() hamburgerView = true;
		private savedRxProp = {
			title: 'Saved Prescription Preference',
			display: '<p>Use a Saved Prescription</p>',
			description:
				'<p>Improve your outcomes by using Saved Prescriptions. ' +
				'From the start screen click <b>Prescription Preferences</b> to create, edit and delete your saved prescription for use later.' +
				' Apply your Saved Prescription when creating a new order modify them as needed to meet your patients unique needs or submit your order request based on your saved prescription.</p>' +
				'<p>To learn more about visit <a href="https://support.ArizeClinical.com">Help & Support</a></p>'
		};
		private showInfo = false;
		private lastAppliedNotes: string = '';
		private savedRxList: SavedRxNames = [];
		private nextButtonDisabled = true;
		private onScreenPreview = false;

		public async prev() {
			await this.$router.push('order-styles');
		}

		@Watch('$route', { immediate: true, deep: true })
		onNavigation(newval: any) {
			this.scrollIntoView();
		}

		activated() {
			this.nextButtonDisabled = true;
			setTimeout(() => {
				console.log('disable false');
				this.nextButtonDisabled = false;
			}, 2500);
			// this.savedRx = null;
		}

		deactivated() {
			if (this.$state.leroy.isOnscreenPreview) {
				this.toggleOnscreenPreview();
			}
		}

		async mounted() {
			this.nextButtonDisabled = true;
			this.savedRxList = await this.$engine.savedRx.getRxList();
			this.$state.prescription.allowUpdate = true;
			this.categoryContainer = this.$refs.categoriesContainer as HTMLDivElement;
			this.scrollIntoView();
			setTimeout(() => {
				console.log('disable false');
				this.nextButtonDisabled = false;
			}, 2500);
		}

		scrollIntoView() {
			if (window.location.hash) {
				const elem = document.getElementsByName(window.location.hash.slice(1))[0];
				if (!elem) {
					return;
				}

				elem.scrollIntoView({ behavior: 'smooth' });
			}
		}

		toggleOnscreenPreview() {
			this.$state.leroy.isOnscreenPreview = !this.$state.leroy.isOnscreenPreview;
		}

		public async savePrescription() {
			await this.$state.prescription.delayedSavePrescription(
				this.$state.prescription.updatedInThisSession,
				SessionStatusEnum.SESSION_STATUS_PRESCRIPTION_CREATED
			);
			await this.$router.push('/summary');
		}

		mapOrthoticStyleToTitle(orthoticStyle) {
			return orthoticStyleToTitle(orthoticStyle);
		}

		mapOrthoticStyleToImagePath(orthoticStyle) {
			return orthoticStyleToImagePath(orthoticStyle);
		}
	}
